module.exports = __webpack_public_path__ + "static/media/map-icon.f444129d.svg";